import { useState } from "react";
import moment from "moment";
import { Box, CircularProgress, Tooltip } from "@mui/material";

import { api } from "../../../lib/api";

import { IAppointmentInternal } from "../../../providers/user/types";

import { useUser } from "../../../providers/user";

import Toast from "../../../utils/toast";
import Modal from 'react-bootstrap/Modal';

interface IAppointmentCancellation {
  modal: boolean;
  setModal: (val: boolean) => void;
  appointment: IAppointmentInternal;
}

const AppointmentCancellation = ({
  modal,
  setModal,
  appointment,
}: IAppointmentCancellation) => {
  const futureTime = 2;
  const { getAppointments } = useUser();
  const { id, date } = appointment;
  const { name, image, gender, crm } = appointment.specialistDoctor;
  const { initialTimeHours, initialTimeMinutes } = appointment.scheduleTime;
  const [removingAppointment, setRemovingAppointment] =
    useState<boolean>(false);

  const removeAppointment = async () => {
    try {
      setRemovingAppointment(true);
      await api.get(`/Attendance/cancel/${id}`);
      getAppointments(futureTime);
      setRemovingAppointment(false);
      setModal(false);
      Toast.fire({
        title: "Consulta cancelada",
        icon: "success",
      });
    } catch (error) {
      setRemovingAppointment(false);
      setModal(false);
      Toast.fire({
        title: "Algo deu errado",
        text: "Por favor, tente novamente mais tarde",
        icon: "warning",
      });
    }
  };

  return (

    <Modal
      show={modal}
      // size="lg"
      onHide={() => setModal(false)}
      backdrop="static"
      keyboard={false}
      className="text-body"
      centered
      scrollable
    >

      <div className="modal-header">
        <h5 className="modal-title">
          <i className="las la-calendar-alt me-3"></i>
          Cancelamento de Consulta
        </h5>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => setModal(false)}
        ></button>
      </div>

      <div className="modal-body bg-light">
        <h6 className="text-muted text-uppercase small">Profissional:</h6>
        <div className="bg-white rounded-4 border p-3 pb-0 mb-4">
          <div className="row align-items-center">
            <div className="col col-auto pb-3 e-0">
              <div className="img-wrap" style={{ width: 60 }}>
                <img
                  alt={`${gender === 0 ? "Dra." : "Dr."} ${name}`}
                  src={
                    image
                      ? image
                      : gender === 0
                        ? "https://conectadoc.com.br/ImgMedico/Thumbs/ThumbFemale.jpg"
                        : "https://conectadoc.com.br/ImgMedico/Thumbs/ThumbMale.jpg"
                  }
                />
              </div>
            </div>

            <div className="col-12 col-sm pb-3">
              <h6 className="text-primary mb-1 small">CRM: {crm}</h6>
              <h5 className="mb-1">
                {gender === 0 ? "Dra." : "Dr."} {name}
                <Tooltip title="Profissional Verificado">
                  <i
                    className="las la-check-circle text-primary ms-2"
                  ></i>
                </Tooltip>
              </h5>
              <h6 className="mb-0">
                {/* {doctor.specialty.length ? doctor.specialty[0].name : ""} */}
              </h6>
            </div>
          </div>
        </div>

        <h6 className="text-muted text-uppercase small">
          Data e hora da consulta:
        </h6>
        <div className="bg-white rounded-4 border p-3 pb-0 mb-4">
          <h5 className="text-center mb-3">
            {moment(new Date(date)).format("L")} -{" "}
            <span className="text-primary">
              {moment(
                `${initialTimeHours}:${initialTimeMinutes}`,
                "HH:mm"
              ).format("HH:mm")}
            </span>
          </h5>
        </div>
        <div className="bg-white rounded-4 border p-3 pb-3 mb-4">
          <h6 className="mb-0 text-uppercase small text-center text-danger">
            Tem certeza que deseja cancelar esta consulta?
          </h6>
        </div>
      </div>
      <div className="modal-footer justify-content-center">
        <button
          disabled={removingAppointment}
          className="btn btn-danger fw-semibold d-flex align-items-center"
          onClick={removeAppointment}
        >
          {removingAppointment ? (
            <CircularProgress size={21} color="inherit" />
          ) : (
            "Confirmar Cancelamento"
          )}
        </button>
      </div>
    </Modal>
  );
};

export default AppointmentCancellation;
